import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';

import { DropdownFilter } from '../../../Planner/Filters/DropdownFilter';
import { useFetchOrgUnitOptions } from '../../../../actions/areas/shared/fetchOptions';

export default function TeamMappingForm({ props }) {
  const teamName = props.selectedRow[1];
  const orgUnitId = props.selectedRow[3];

  const [state, setState] = useState({ selectedOrgUnitId: orgUnitId });
  const { data: orgUnitOptions } = useFetchOrgUnitOptions(false, true, false);

  const canSave = state.selectedOrgUnitId && state.selectedOrgUnitId !== '';
  if (orgUnitId) {
    orgUnitOptions.push({ id: orgUnitId, name: props.selectedRow[4], isActive: false });
  }

  const locale = props.events.locale;

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '400px' }}>
          <div className="sidePanel-header form-header">
            <div className="sidePanel-header-subtitle">
              <Box display="flex">
                <Box flexGrow={1} py={1}>
                  <Typography variant="subtitle1">{locale.getMsg('providerTeamMapping')}</Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => props.events.handleSidePanel(false)}>
                    <CancelIcon />
                  </IconButton>
                </Box>
              </Box>
            </div>
          </div>
          <div className="sidePanel-content content-top-padding">
            <Typography variant="h6" gutterBottom>
              {locale.getMsg('providerTeamName')}
            </Typography>
            <TextField fullWidth value={teamName} disabled />
            <Typography variant="h6" gutterBottom className="text-as-separator">
              {locale.getMsg('mapTeamTo')}
            </Typography>
            <Typography variant="h6" gutterBottom>
              {locale.getMsg('orgUnitName')}
            </Typography>
            <DropdownFilter
              fullWidth
              data={orgUnitOptions}
              defaultValue={state.selectedOrgUnitId}
              filterKey={'orgUnit'}
              filterValue={state.selectedOrgUnitId}
              onChange={(name, value) => setState({ ...state, selectedOrgUnitId: value })}
            />
          </div>
          <div className="sidePanel-footer">
            <div className="sidePanel-buttons">
              <div className="sidePanel-BackButton">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => props.events.handleSidePanel(false)}
                  style={{ marginRight: '10px' }}
                >
                  {locale.getMsg('back')}
                </Button>
              </div>
              <div className="sidePanel-saveButton">
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!canSave}
                  onClick={() => {
                    if (orgUnitId !== state.selectedOrgUnitId) {
                      props.events.editProviderTeamMappingModel({ teamName, orgUnitId: state.selectedOrgUnitId });
                    } else {
                      props.events.handleSidePanel(false);
                    }
                  }}
                >
                  {locale.getMsg('edit')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </SwipeableDrawer>
    </section>
  );
}
